import { makeRequest } from "@/shared/services/http";
import { IDocumentsGetResponse } from "./models/response";

const controllerName = 'documents';

export class DocumentsController {

    static get(path: string): Promise<IDocumentsGetResponse> {
        return makeRequest('get', controllerName, '', { params: { path } });
    }
}